import * as React from 'react';
import * as style from './style.css';
import { UIText1 } from '@cian/ui-kit';
import { Link } from '../Link';
import { DecorationLabel } from '../Labels';
import { Compare } from '../Compare';
import { Favorite } from '../Favorite';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var OffersRow = function OffersRow(_ref) {
  var offer = _ref.offer,
    onOfferLinkClick = _ref.onOfferLinkClick;
  return /*#__PURE__*/_jsxs("div", {
    className: style['row'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['offer-title'],
      children: [/*#__PURE__*/_jsx(UIText1, {
        children: /*#__PURE__*/_jsx(Link, {
          href: offer.url,
          target: "_blank",
          onClick: onOfferLinkClick,
          children: offer.title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: style['labels'],
        children: offer.hasDecoration && /*#__PURE__*/_jsx(DecorationLabel, {})
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "current_color",
        children: offer.dueDate
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "current_color",
        children: offer.floor
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "text-primary-default",
        textAlign: "right",
        as: "span",
        children: offer.price
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style['controls-cell'],
      children: [/*#__PURE__*/_jsx(Compare, {
        status: offer.offersComparisonStatus.status,
        offerId: offer.id
      }), /*#__PURE__*/_jsx(Favorite, {
        isFavorite: offer.isFavorite,
        offerId: offer.id
      })]
    })]
  });
};